import { parseBuildInfo, type AppBuildInfo } from '@nexops/shared';

/** Build opublikowany teraz na serwerze (`/version.json`, bez cache); null przy błędzie sieci lub nieprawidłowej odpowiedzi. */
export async function fetchRemoteBuild(): Promise<AppBuildInfo | null> {
  try {
    const res = await fetch(`${import.meta.env.BASE_URL}version.json?t=${Date.now()}`, { cache: 'no-store', credentials: 'omit' });
    if (!res.ok) return null;
    return parseBuildInfo(await res.json());
  } catch {
    return null;
  }
}
